import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import MyLink from "../../components/myLink";
import EMTLevel from "../../components/emtLevel";
import Caution from "../../components/caution";
import Note from "../../components/note";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>
      <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
        1.0 Routine Patient Care
      </MyLink>
    </li>
    <li>
      <h4 id="mild-distress" style={{
            padding: '0.25rem 0.5rem 0 0',
            display: "inline-block"
          }}>
        MILD DISTRESS:
      </h4>
      The following may be considered if the patient has not taken the
      prescribed maximum dose of their own inhaler prior to the arrival of EMS: and the inhaler is present:
    </li>
    <ul>
      <li>
        Encourage and/or assist patient to self-administer their own prescribed inhaler medication if indicated or if not already done.
      </li>
      <li>
        If patient is unable to self-administer their prescribed inhaler, administer patient’s prescribed inhaler.
      </li>
      <li>
        Reassess vital signs.
      </li>
    </ul>
    <h4 style={{
          "marginTop": "1rem"
        }} id="medical-control-orders">
      MEDICAL CONTROL MAY ORDER:
    </h4>
        <li>
  Additional doses of above medications, if prescribed to patient or authorized, and if
  maximum dose has not been administered.
        </li>

        <li>
  NOTE: EMT-B and AEMT administration of an inhaler is
  <strong> CONTRAINDICATED</strong>, if:
        </li>
        <ul>
  <li>
    The maximum dose has been administered prior to the arrival of the EMT.
  </li>
  <li>
    The patient cannot physically use the device properly. (Patient cannot receive
    inhalation properly.)
  </li>
  <li>
    The device has not specifically been prescribed for the patient.
  </li>
  <li>
    **If properly trained and authorized, use

    <MyLink to="/sections/6/6.01-bls-bronchodilators" mdxType="MyLink">
      6.1 BLS Albuterol.
    </MyLink>
  </li>
        </ul>
  </ul>
  <strong style={{
        "display": "inline-block",
        "marginTop": "1rem",
        "marginBottom": "0.25rem"
      }}>
    SEVERE DISTRESS:
  </strong>
  <ul>
    <li>
      If patient is over 6 months age and under 25kg, administer epinephrine 0.15mg
      via auto-injector or IM.
    </li>
    <li>
      If body weight is over 25 kg, administer epinephrine
      0.3mg via auto-injector or IM.
    </li>
        <li>
  When administering IM, EMTs may do so in
  accordance with Protocol
  <MyLink to="/sections/6-06-check-inject-epinephrine-emt-basic" mdxType="MyLink">
    6.6 Check and Inject Epinephrine for BLS Providers.
  </MyLink>
        </li>
        <li>
  Contact Medical Control if second dose is required after 5 minutes.
        </li>
  </ul>
      <strong>
  Criteria for epinephrine administration:
      </strong>
      <ul>
  <li>
    Age greater than or equal to 6 months
  </li>
  <li>
    Known history of asthma or reactive airway disease or bronchospasm or
    bronchodilators prescribed AND
  </li>
  <li>
    Patient in respiratory arrest or approaching respiratory arrest(requiring BVM) -
    include:
  </li>
  <ul>
    <li>
      Diminished or absent breath sounds <strong>AND</strong>
    </li>
    <li>Oxygen saturation less than 91% despite supplemental oxygen or unmeasurable.</li>
  </ul>
      </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  <ul>
    <li>
      If the condition is not improving with administration of supplemental oxygen,
      consider the following:
    </li>
    <li>
      Albuterol sulfate 1.25 mg with ipratropium bromide, 250 mcg via nebulizer if
      less than 2 years of age.
    </li>
    <li>
      Albuterol sulfate 2.5-3 mg with ipratropium bromide, 500 mcg via nebulizer if
      age 2 years or greater.
    </li>
    <li>
      A second dose of albuterol, with or without ipratropium bromide, may be
      administered as necessary.
    </li>
  </ul>
      <strong>Note:</strong> a multi-dose inhaler may be used to give albuterol or ipratropium (instead of
nebulizer) if infection control is an issue (e.g., influenza-like-illness).
      <strong style={{
        "display": "block",
        "marginTop": "1rem",
        "marginBottom": "0.5rem"
      }}>
  ADVANCED EMT STANDING ORDERS
      </strong>
      <ul>
  <strong>
    SEVERE DISTRESS:
  </strong>
  <li>
    If patient is over 6 months age and under 25kg, administer epinephrine 0.15mg
    via auto-injector or IM. If body weight is over 25 kg, administer epinephrine
    0.3mg via auto-injector or IM.
  </li>
  <li>
    Contact Medical Control if second dose is required after 5 minutes
  </li>
      </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>
      For a child age 2 years old or more who has a known diagnosis of asthma,
      consider:
      <ul>
        <li>hydrocortisone 2 mg/kg to max. 100 mg IV/IO/IM; or</li>
        <li>methylprednisolone 2 mg/kg to max. 125 mg IV/IO/IM.</li>
      </ul>
    </li>
    <li>
      Consider magnesium sulfate 25 mg/kg IV/IO over 10 min. (maximum dose 2
      grams).
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" medControl="{true}" mdxType="EMTLevel">
  <ul>
    <li>Additional doses of above medications.</li>
  </ul>
    </EMTLevel>
    <Caution id="caution-1" mdxType="Caution">
  Epinephrine for anaphylaxis must be administered by Auto-Injector or IM if
  trained and authorized to do so in accordance with:
  <MyLink to="/sections/6/6-6-check-inject-epinephrine-emt-basic" mdxType="MyLink">
    Medical Director Option Protocol 6.6
    Check and Inject Epinephrine for BLS Providers
  </MyLink>
    </Caution>
    <Caution id="caution-2" mdxType="Caution">
  For patients under 12 years old, the airway is in most cases best managed with a BVM or SGA.
  <div>
    In some cases, intubation may be preferred. This is at the discretion of the treating paramedic.
  </div>
    </Caution>
    <Note id="note-1" alignment="left" mdxType="Note">
  <div>
    <strong>Mild distress </strong>in children is evidenced by minor wheezing and good air entry.
  </div>
  <div style={{
        "margin": "1.25rem 0"
      }}>
    <strong>Severe distress</strong> in children is evidenced by poor air entry, extreme use of accessory muscles,
    nasal flaring, grunting, cyanosis and/or altered mental status (weak cry, somnolence, poor
    responsiveness). <strong>REMEMBER:</strong> Severe bronchospasm may present without wheezes, if there is
    minimal air movement.
  </div>
  <div>
    <strong>Respiratory Distress</strong> is defined as inadequate breathing in terms of rate, rhythm, quality and/or
    depth of breathing. Children who are breathing too fast or slow, or in an abnormal pattern or
    manner, may not be receiving enough oxygen to support bodily functions and may allow an
    increase in carbon dioxide to dangerous levels. Cyanosis is usually a late sign and requires
    immediate treatment.
  </div>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      